import React from 'react';
import PropTypes from 'prop-types';
import { Button, DialogActions, DialogContent } from '@material-ui/core';
import DialogComponent from '../shared/DialogComponent';

function DeleteInterviewDialog(props) {
    const { open, close, removeInterview } = props;
    return (
        <DialogComponent title="Delete Interview" size="sm" open={open} onClose={close}>
            <DialogContent>
                <p className="font-18">Are you sure you want to delete the interview?</p>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={close}
                    variant="outlined"
                    color="primary"
                    className="text-capitalize mr-2 width-md"
                >
                    No
                </Button>
                <Button
                    onClick={removeInterview}
                    variant="contained"
                    color="primary"
                    className="text-capitalize width-md"
                >
                    Yes
                </Button>
            </DialogActions>
        </DialogComponent>
    );
}

DeleteInterviewDialog.propTypes = {
    open: PropTypes.bool,
    close: PropTypes.func,
    removeInterview: PropTypes.func,
};

export default DeleteInterviewDialog;
